import { render } from "./ProductAggregatedFilter.vue?vue&type=template&id=432977bb&ts=true"
import script from "./ProductAggregatedFilter.vue?vue&type=script&lang=ts"
export * from "./ProductAggregatedFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__